import { defaultDictionaryValueMissing } from '../repository';

export type ExplainerKey = 'SkipToMain';

export const getDefaultExplainerValue = (key: ExplainerKey): string => {
	switch (key) {
		case 'SkipToMain':
			return 'Klik for at springe navigationen over og gå direkte til indholdssektion';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
